import {
    GET_SPECIALITY_BY_REGION_REQUEST,
    GET_SPECIALITY_BY_REGION_SUCCESS,
    GET_SPECIALITY_BY_REGION_ERROR
} from "../actions/types";

export const specialityByRegion = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_SPECIALITY_BY_REGION_REQUEST:
            return {
                loading: true,
            };
        case GET_SPECIALITY_BY_REGION_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_SPECIALITY_BY_REGION_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };

        default: {
            return state;
        }
    }
};